
// src/connects/likes-readers-page.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import find from 'lodash/find'
import flatten from 'lodash/flatten'

export const mapStateToProps = (state, ownProps)=> {
  return {
    diaries: state.subDiaries.items,
    isFetching: state.subDiaries.isFetching,
    likeConfig: state.likes.likeConfig,
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const diary = find(stateProps.diaries, (item)=> item.diary_id == ownProps.params.diary_id)

  const comments = ownProps.params.comment_id && diary && flatten(diary.comments.concat(diary.comments.map((c)=> c.comments)))
  const comment = comments && find(comments, (item)=> item && item.comment_id == ownProps.params.comment_id)
  return {
    diary,
    comment,
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    showUser:  (userId)=> {
      dispatch(actions.openRightSidePage(
        'user_timeline', {
          group_id: ownProps.group && ownProps.group.group_id || undefined,
          user_id: userId
        }))
    },
    willMount: ()=> {
      dispatch(actions.fetchSubDiary(ownProps.params.diary_id, true))
    },

    willUpdate: (props, nextProps)=> {
      if (props.params.diary_id != nextProps.params.diary_id)
        dispatch(actions.fetchSubDiary(nextProps.params.diary_id, true))
      if (props.params.diary_id != nextProps.params.diary_id || props.params.comment_id != nextProps.params.comment_id){
        switch (nextProps.params.tab) {
          case 'likes':
            nextProps.updateUI({ index: 0 })
            break
          case 'comments':
            nextProps.updateUI({ index: 1 })
            break
          case 'mentions':
            nextProps.params.diary_id && nextProps.params.comment_id ? nextProps.updateUI({ index: 1 }) : nextProps.updateUI({ index: 2 })
            break
          case 'readers':
            nextProps.updateUI({ index: 3 })
            break
          default:
            nextProps.updateUI({ index: 0 })
        }
      }else if(props.params.tab != nextProps.params.tab){
        switch (nextProps.params.tab) {
          case 'likes':
            nextProps.updateUI({ index: 0 })
            break
          case 'comments':
            nextProps.updateUI({ index: 1 })
            break
          case 'mentions':
            nextProps.params.diary_id && nextProps.params.comment_id ? nextProps.updateUI({ index: 1 }) : nextProps.updateUI({ index: 2 })
            break
          case 'readers':
            nextProps.updateUI({ index: 3 })
            break
          default:
            nextProps.updateUI({ index: 0 })
        }
      }
    },

    willUnmount: ()=> dispatch(actions.clearSubDiaries())
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  ui({
    state: {
      index: (props)=> {
        switch (props.params.tab) {
        case 'likes':
          return 0
        case 'comments':
            return 1
        case 'mentions':
          if (props.params.diary_id && props.params.comment_id)
            return 1
          else
            return 2
        case 'readers':
            return 3
        default:
          return 0
        }
      }
    }
  }),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/likes-readers-page.js